import { PricingLayout } from "../../../types";

// SYNC: duplicated in server, dooms-operator, and dooms-customer — changes must be mirrored
export type PricingLineItemKey =
  | "driverGratuity"
  | "promoDiscount"
  | "tax"
  | "tolls"
  | "meetGreet"
  | "other"
  | "other2"
  | "other3"
  | "other4"
  | "other5"
  | "other6"
  | "stc"
  | "creditCardServiceFee";

const DEFAULT_ORDER: PricingLineItemKey[] = [
  "driverGratuity",
  "tax",
  "promoDiscount",
  "tolls",
  "meetGreet",
  "other",
  "other2",
  "other3",
  "other4",
  "other5",
  "other6",
  "stc",
  "creditCardServiceFee",
];

export type PricingGroups = {
  subtotalItems: PricingLineItemKey[];
  calculatedOnSubtotalItems: PricingLineItemKey[];
};

export const derivePricingGroups = (
  pricingLayout: Pick<PricingLayout, "calculatedOnSubtotalItems" | "subtotalOrder" | "calculatedOnSubtotalOrder"> | null
): PricingGroups => {
  const calcItems = (pricingLayout?.calculatedOnSubtotalItems || []).filter(Boolean) as PricingLineItemKey[];

  if (calcItems.length === 0) {
    return {
      subtotalItems: DEFAULT_ORDER,
      calculatedOnSubtotalItems: [],
    };
  }

  const calcSet = new Set(calcItems);

  const subOrder = (pricingLayout?.subtotalOrder || []).filter(Boolean) as PricingLineItemKey[];
  const calcOrder = (pricingLayout?.calculatedOnSubtotalOrder || []).filter(Boolean) as PricingLineItemKey[];

  const subtotalItems =
    subOrder.length > 0
      ? subOrder.filter((k) => !calcSet.has(k))
      : DEFAULT_ORDER.filter((k) => !calcSet.has(k));

  const calculatedOnSubtotalResult =
    calcOrder.length > 0
      ? calcOrder.filter((k) => calcSet.has(k))
      : DEFAULT_ORDER.filter((k) => calcSet.has(k));

  // Append any items from DEFAULT_ORDER that aren't in either group
  // (e.g. newly enabled items not yet in saved orders)
  const allIncluded = new Set([...subtotalItems, ...calculatedOnSubtotalResult]);
  for (const key of DEFAULT_ORDER) {
    if (!allIncluded.has(key)) {
      subtotalItems.push(key);
    }
  }

  return { subtotalItems, calculatedOnSubtotalItems: calculatedOnSubtotalResult };
};
